import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "modal-container" };
const _hoisted_2 = { class: "share-options" };
const _hoisted_3 = { class: "share-section" };
const _hoisted_4 = {
    key: 0,
    class: "error"
};
const _hoisted_5 = ["disabled"];
const _hoisted_6 = {
    key: 0,
    class: "share-section"
};
import { reactive, ref, watch, onMounted } from 'vue';
import { useShareRecommendation } from '../../composables/useShareRecommendation';
import { useVehicleDetails } from '../../composables/useVehicleDetails';
import { useShareService } from '../../composables/useShareService';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ShareRecommendationModal',
    setup(__props) {
        const { isShareModalOpen: isOpen, closeShareModal: close } = useShareRecommendation();
        const { vehicleDetails } = useVehicleDetails();
        const shareService = useShareService();
        const form = reactive({
            email: ''
        });
        const canShare = ref(false);
        onMounted(() => {
            canShare.value = typeof navigator !== 'undefined' && !!navigator.share;
        });
        const resetForm = () => {
            form.email = '';
        };
        const handleEmailSubmit = async () => {
            try {
                await shareService.shareViaEmail(form, vehicleDetails.value ?? null);
                resetForm();
                close();
            }
            catch (err) {
                console.error('Email share error:', err);
            }
        };
        const handleDeviceShare = async () => {
            try {
                await shareService.shareViaDevice(vehicleDetails.value ?? null);
                close();
            }
            catch (err) {
                if (err.name !== 'AbortError') {
                    console.error('Device share error:', err);
                }
            }
        };
        // Lock body scroll while modal is open
        watch(isOpen, val => {
            document.body.style.overflow = val ? 'hidden' : 'auto';
            // Reset error when modal opens
            if (val) {
                shareService.resetError();
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                        (_unref(isOpen))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "modal-backdrop",
                                onClick: _cache[2] || (_cache[2] = _withModifiers(
                                //@ts-ignore
                                (...args) => (_unref(close) && _unref(close)(...args)), ["self"]))
                            }, [
                                _createElementVNode("div", _hoisted_1, [
                                    _createElementVNode("button", {
                                        class: "modal-close",
                                        onClick: _cache[0] || (_cache[0] =
                                            //@ts-ignore
                                            (...args) => (_unref(close) && _unref(close)(...args)))
                                    }, "×"),
                                    _cache[8] || (_cache[8] = _createElementVNode("h2", null, "Share this recommendations", -1)),
                                    _cache[9] || (_cache[9] = _createElementVNode("p", null, "Choose how you'd like to share the product recommendations", -1)),
                                    _createElementVNode("div", _hoisted_2, [
                                        _createElementVNode("div", _hoisted_3, [
                                            _cache[4] || (_cache[4] = _createElementVNode("h3", null, "Share via Email", -1)),
                                            _createElementVNode("form", {
                                                onSubmit: _withModifiers(handleEmailSubmit, ["prevent"])
                                            }, [
                                                _createElementVNode("label", null, [
                                                    _cache[3] || (_cache[3] = _createTextVNode(" Email ", -1)),
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((form.email) = $event)),
                                                        type: "email",
                                                        required: ""
                                                    }, null, 512), [
                                                        [_vModelText, form.email]
                                                    ])
                                                ]),
                                                (_unref(shareService).errorMessage)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(shareService).errorMessage), 1))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("button", {
                                                    type: "submit",
                                                    disabled: _unref(shareService).isLoading
                                                }, _toDisplayString(_unref(shareService).isLoading ? 'Sending…' : 'Send Email'), 9, _hoisted_5)
                                            ], 32)
                                        ]),
                                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "separator" }, null, -1)),
                                        (canShare.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "share-section__content" }, [
                                                    _createElementVNode("h3", null, "Share via Device"),
                                                    _createElementVNode("p", { class: "device-share-description" }, " Use your device's native share menu to send via apps, messages, or social media ")
                                                ], -1)),
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "share-button",
                                                    onClick: handleDeviceShare
                                                }, [...(_cache[5] || (_cache[5] = [
                                                        _createElementVNode("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            width: "20",
                                                            height: "20",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            stroke: "currentColor",
                                                            "stroke-width": "2",
                                                            "stroke-linecap": "round",
                                                            "stroke-linejoin": "round"
                                                        }, [
                                                            _createElementVNode("circle", {
                                                                cx: "18",
                                                                cy: "5",
                                                                r: "3"
                                                            }),
                                                            _createElementVNode("circle", {
                                                                cx: "6",
                                                                cy: "12",
                                                                r: "3"
                                                            }),
                                                            _createElementVNode("circle", {
                                                                cx: "18",
                                                                cy: "19",
                                                                r: "3"
                                                            }),
                                                            _createElementVNode("line", {
                                                                x1: "8.59",
                                                                y1: "13.51",
                                                                x2: "15.42",
                                                                y2: "17.49"
                                                            }),
                                                            _createElementVNode("line", {
                                                                x1: "15.41",
                                                                y1: "6.51",
                                                                x2: "8.59",
                                                                y2: "10.49"
                                                            })
                                                        ], -1),
                                                        _createTextVNode(" Share Now ", -1)
                                                    ]))])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
